import React from 'react';
import { Link } from 'react-router-dom';
import { IconButton, Tooltip } from '@mui/material';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { PRIMARY_BLUE } from '../../styles/foundation/colors';
import { orderDetailPath } from './constants';

/** Eye icon that opens the shipment's order details in a new tab (same as the AWB link). View only, no actions. */
export default function ViewOrderButton({ awb }) {
  if (!awb) return null;
  return (
    <Tooltip title='View order details' arrow>
      <IconButton component={Link} to={orderDetailPath(awb)} target='_blank' rel='noopener noreferrer' size='small'
        aria-label={`View order details for ${awb}`} sx={{ color: PRIMARY_BLUE }}>
        <VisibilityOutlinedIcon sx={{ fontSize: 18 }} />
      </IconButton>
    </Tooltip>
  );
}

/** Narrow last column for the list tables. */
export const viewColumn = {
  field: 'view', headerName: 'View', width: '6%',
  renderCell: ({ row }) => <ViewOrderButton awb={row?.awb_number} />,
};
